module.exports = __webpack_public_path__ + "img/gold_frame.1d17338e.png";